import { Controller } from "@hotwired/stimulus"

// Simple controller to show/hide project selector dropdown
export default class extends Controller {
  static targets = ["display", "selector", "form", "select"]

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.selectorTarget.classList.toggle("hidden")

    if (!this.selectorTarget.classList.contains("hidden")) {
      // Focus the select when opening
      this.selectTarget.focus()
      // Set up click-outside listener
      this.boundClickOutside = this.clickOutside.bind(this)
      document.addEventListener("click", this.boundClickOutside)
    } else {
      this.removeClickOutside()
    }
  }

  submit() {
    // Submit the form when selection changes
    this.formTarget.requestSubmit()
    this.hide()
  }

  hide() {
    this.selectorTarget.classList.add("hidden")
    this.removeClickOutside()
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  removeClickOutside() {
    if (this.boundClickOutside) {
      document.removeEventListener("click", this.boundClickOutside)
      this.boundClickOutside = null
    }
  }

  disconnect() {
    this.removeClickOutside()
  }
}
